// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__Uyc0u","colCheckbox":"styles_colCheckbox__3DtMM"};